var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-layout',{attrs:{"wrap":"","align-center":"","justify-center":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h1',[_vm._v("My Application")])]),_vm._v(" "),_c('application-client-settings')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-181f99b1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/applicationClient/myApplication.vue
// module id = null
// module chunks = 